

define(function (require, exports, module) {
    /**
     * @file 继承并在原型链中提供`Parent`方法，用于调用父类prototype中的方法
     * @author 子虔
     * @date    2015-02-15 15:11:23
     */
    module.exports = function (child, parent, protoProps, staticProps) {
        // 绑定静态属性
        $.extend(child, parent, staticProps);

        function Prototype() {
            this.constructor = child;
        }

        Prototype.prototype = parent.prototype;

        child.prototype = new Prototype();

        // 绑定新的属性
        if (protoProps) {
            $.extend(child.prototype, protoProps);
        }

        // merge the Class's default's prototype
        child.prototype.defaults = $.extend(true, {}, parent.prototype.defaults, child.prototype.defaults);

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;
        child.__class__ = [];

        if (!parent.__class__) {
            child.__class__.push(parent, child);
        } else {
            parent.__class__.forEach(function (item) {
                child.__class__.push(item);
            });
            child.__class__.push(child);
        }

        child.prototype.Parent = function Parent() {
            var caller,
                name,
                parent,
                allClass = this.constructor.__class__,
                allClassLength = allClass.length,
                i = allClassLength - 1,
                args = arguments,
                argsLen = args.length;

            if (argsLen == 2 && typeof args[0] == 'function' && isArgsObject(args[1])) {
                caller = args[0];
                args = args[1] || [];
            } else {
                caller = Parent.caller;
                args = arguments;
            }

            if (!caller) return;

            while (i > 0 && !name) {
                var fun = allClass[i],
                    fn = fun.prototype;
                for (var p in fn) {
                    if (fn.hasOwnProperty(p) && fn[p] === caller) {
                        name = p;
                        parent = allClass[i - 1];
                    }
                }
                i--;
            }

            if (name && parent) {
                if (parent.prototype[name]) {
                    return parent.prototype[name].apply(this, args);
                }
            }
        };
    };

    // 判断一个对象是否为arguments对象
    function isArgsObject(obj) {
        var type = Object.prototype.toString.call(obj);
        return type === '[object Arguments]';
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-base/dist/inherits.js
// module id = 336
// module chunks = 0 1